// Thinking-page API. The link token comes from the URL fragment and travels in a header.
import { request } from "./client";
import type { components } from "./schema";

type Schemas = components["schemas"];
export type ThinkingView = Schemas["ThinkingView"];
export type TextStepModel = Schemas["TextStep"];
export type Submission = Schemas["Submission"];
export type SubmitResult = Schemas["SubmitResult"];
/** What a step component provides; the page adds step, timing and telemetry flags. */
export type StepFields = Partial<Omit<Submission, "step" | "client_telemetry">>;

function headers(token: string): Record<string, string> {
  return { "X-Thinking-Token": token, "Content-Type": "application/json" };
}

export const thinkingApi = {
  view: (token: string) => request<ThinkingView>("/api/thinking", { headers: headers(token) }),
  start: (token: string, extraTime: boolean) =>
    request<ThinkingView>("/api/thinking/start", {
      method: "POST",
      headers: headers(token),
      body: JSON.stringify({ extra_time: extraTime }),
    }),
  submit: (token: string, submission: Submission) =>
    request<SubmitResult>("/api/thinking/submit", {
      method: "POST",
      headers: headers(token),
      body: JSON.stringify(submission),
    }),
};

export function tokenFromHash(hash: string): string {
  return hash.replace(/^#/, "").trim();
}
